import React from 'react'
import {Companies} from "../../Constants/companies";

const Footer = () =>  (
    <footer className="app-footer">
        &copy; {Companies.Spiris} {new Date().getFullYear()}
    </footer>
)

export default Footer;